import React from 'react'
import { useSelector } from 'react-redux'
import s from './CityLayerLinks.less'
import { getBicycleLinks, getRestrictionLinks, getTrafficLinks, getZfeLinks } from './footer/common/topSearchLayerPages'
import { ROUTE_BICYCLE_CITY, ROUTE_RESTRICTION_CITY, ROUTE_TRAFFIC_CITY, ROUTE_ZFE_CITY } from '../../routes'
import { selectCurrentHistoryRoute } from '../../store/history/history.selectors'
import useFirstAddressWithTownSeoPostcode from './useFirstAddressWithTownSeoPostcode'

const CityLayerLinks = () => {
  const { postcode } = useFirstAddressWithTownSeoPostcode()
  const currentRoute = useSelector(selectCurrentHistoryRoute)
  const trafficLink = currentRoute !== ROUTE_TRAFFIC_CITY && getTrafficLinks({ zip: postcode })?.[0]
  const bikeLink = currentRoute !== ROUTE_BICYCLE_CITY && getBicycleLinks({ zip: postcode })?.[0]
  const zfeLink = currentRoute !== ROUTE_ZFE_CITY && getZfeLinks({ zip: postcode })?.[0]
  const restrictionLink = currentRoute !== ROUTE_RESTRICTION_CITY && getRestrictionLinks({ zip: postcode })?.[0]

  if (!trafficLink?.url && !bikeLink?.url && !zfeLink?.url) return <></>

  return (
    <div className={s.root}>
      <span>Sur la carte vous pouvez aussi afficher : </span>
      {trafficLink?.url && <a href={trafficLink.url}>{trafficLink.label}</a>}
      {bikeLink?.url && <a href={bikeLink.url}>{bikeLink.label}</a>}
      {zfeLink?.url && <a href={zfeLink.url}>{zfeLink.label}</a>}
      {restrictionLink?.url && <a href={restrictionLink?.url}>{restrictionLink.label}</a>}
    </div>
  )
}

export default CityLayerLinks
